import React from 'react'
import PropTypes from 'prop-types'
import TimelineItem from './TimelineItem'

function Events({ castrationCity, events, regionsWithPolygon }) {
  return (
    <div className="timeline">
      {
        events.map((event, index) => (
          <TimelineItem
            castrationCity={castrationCity}
            regionsWithPolygon={regionsWithPolygon}
            key={event?.id}
            index={index}
            event={event}
          />
        ))
      }
    </div>
  )
}

Events.propTypes = {
  events: PropTypes.arrayOf(Object),
  regionsWithPolygon: PropTypes.arrayOf(Object),
  castrationCity: PropTypes.objectOf(Object),
}

Events.defaultProps = {
  events: [],
  regionsWithPolygon: [],
  castrationCity: null,
}

export default Events
